import { DangerButton } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { DeleteOsrContext } from './DeleteOsrContext'

export default function DeleteOsrButton() {
  const { t } = useTranslation()
  const { owsIdsToDelete, handleDeleteOsrs } = useContext(DeleteOsrContext)

  return (
    <DangerButton
      id="deleteOsrButton"
      onClick={handleDeleteOsrs}
      disabled={!owsIdsToDelete || owsIdsToDelete.length < 1}
    >
      {t('ordinances.deleteOsrs', 'Delete OSR(s)')}
    </DangerButton>
  )
}
